import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import SelectorsApp from '@sharedComponent/app-action-reducer/selectors';
import Selectors from '../selectors';
import Actions from '../action';

import EditCampaignPresentational from './edit-campaign-presentational';

const EditCampaignFunctional = ({
	userDetails,
	getDomains,
	campaignDDListLoading,
	domainList,
	domainListLoading,
	editCampaignLoading,
	editCampaign,
}) => {
	const {
		location: {
			state: { detail },
		},
	} = useHistory();

	const [campaign, setcampaign] = useState({
		...detail,
	});

	const clientSourceId = detail.clientSourceId;

	const [domains, setdomains] = useState(domainList);
	const { type, affId } = useParams();
	const history = useHistory();
	const [value, setValue] = useState(1);

	const onChange = (e) => {
		setValue(e.target.value);
	};

	const handleChange = ({ target: { name, value } }, isSourceValue = false) => {
		setcampaign({
			...campaign,
			[name]: value,
		});
	};

	const addDomain = (domain) => {
		const tempDomains = domains;
		tempDomains.unshift({
			key: tempDomains.length,
			domainName: domain,
			domainId: 0,
		});
		setdomains([...tempDomains]);
	};
	const editDomain = (data) => {
		const elementsIndex = domains.findIndex((todo) => todo.key === data.key);
		let newArray = [...domains];
		newArray[elementsIndex] = { ...newArray[elementsIndex], domainName: data.domainName };
		setdomains([...newArray]);
	};
	const removeDomain = (key) => {
		const tempDomains = domains.filter((domain) => domain.key !== key);
		setdomains([...tempDomains]);
	};

	const saveCampaign = () => {
		if (userDetails) {
			delete campaign.campaignName;
			delete campaign.clientSourceId;
			editCampaign(
				{
					...campaign,
					authKey: userDetails.authKey,
					companyId: userDetails.companyId,
					domainNameList: domains.map((domain) => {
						return { domainId: domain.domainId, domainName: domain.domainName };
					}),
				},
				history
			);
		}
	};

	const { campaignId, sourceId } = detail;

	useEffect(() => {
		getDomains({ campaignId, sourceId }, history);
		return () => {
			setdomains([]);
		};
	}, []);

	useEffect(() => {
		setdomains(domainList);
	}, [domainList]);

	return (
		<EditCampaignPresentational
			editCampaignLoading={editCampaignLoading}
			onChange={onChange}
			affId={affId}
			value={value}
			type={type}
			history={history}
			domains={domains}
			campaign={campaign}
			removeDomain={removeDomain}
			addDomain={addDomain}
			editDomain={editDomain}
			handleChange={handleChange}
			saveCampaign={saveCampaign}
			campaignDDListLoading={campaignDDListLoading}
			domainListLoading={domainListLoading}
			clientSourceId={clientSourceId}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		userDetails: SelectorsApp.userDetails(state),
		campaignDDList: Selectors.campaignDDList(state),
		campaignDDListLoading: Selectors.campaignDDListLoading(state),
		editCampaignLoading: Selectors.editCampaignLoading(state),
		domainListLoading: Selectors.domainListLoading(state),
		domainList: Selectors.domainList(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getDomains: (request, history) => dispatch(Actions.creators.getDomains(request, history)),
		editCampaign: (request, history) => dispatch(Actions.creators.editCampaign(request, history)),
	};
};
const Connected = connect(mapStateToProps, mapDispatchToProps)(EditCampaignFunctional);

export default Connected;
